// extracted by mini-css-extract-plugin
export default {"cards":"SettingsPage_cards__aD+42"};